import { render, staticRenderFns } from "./ShowcaseSliderProducts.vue?vue&type=template&id=682702c3&"
import script from "./ShowcaseSliderProducts.vue?vue&type=script&lang=js&"
export * from "./ShowcaseSliderProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports